import { useNavigate } from "react-router-dom";
import Footer from "../Components/Footer/Footer";
//import Header from "../Components/Header/Header";

// Layout per le pagine pubbliche (senza autenticazione)
const PublicLayout = (props: any) => {

    return (
        <div className={props.class}>
            {props.children}
            {/* <Footer /> */}
        </div >
    );
};

export default PublicLayout;